import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#0f766e',
        secondary: '#1d4ed8',
        accent: '#14b8a6',
        info: '#0284c7',
        success: '#059669',
        warning: '#d97706',
        error: '#dc2626',
        surface: '#ffffff',
        background: '#f4f7fb',
      },
    },
  },
});
